import { Bell } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '~/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '~/components/ui/dropdown-menu';

/**
 * Notifications bell with an unread dot. Phase 5 ships the affordance + an empty
 * dropdown; the real inbox is a later task. `hasUnread` is hard-coded until then.
 */
export function NotificationsBell({ hasUnread = false }: { hasUnread?: boolean }) {
	const { t } = useTranslation();
	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button variant="ghost" size="icon-sm" className="relative" aria-label={t('shell.notifications.label')}>
					<Bell size={16} />
					{hasUnread && <span className="absolute top-1 right-1 size-1.5 rounded-full bg-danger-strong" />}
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end" className="min-w-[220px]">
				<div className="px-2 py-6 text-center text-xs text-foreground-subtle">{t('shell.notifications.empty')}</div>
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
